import InfoIconTooltip from "@components/dataDisplay/tooltips/InfoIconTooltip";
import Typography from "@components/typography";
import React, { FC, ReactNode } from "react";
import * as styles from "./Header.css";

export interface HeaderProps {
  LeftActions?: FC;
  RightActions?: FC;
  level?: 1 | 2 | 3 | 4 | 5;
  title: string;
  titleTooltip?: ReactNode;
  "data-testid"?: string;
}
const Header: FC<HeaderProps> = ({
  RightActions,
  LeftActions,
  level = 3,
  title,
  titleTooltip,
  ...rest
}) => {
  const iconSize = {
    1: 38,
    2: 30,
    3: 24,
    4: 20,
    5: 16,
  };

  return (
    <div data-testid={rest?.["data-testid"]} className={styles.headerContainer}>
      <div className={styles.headerLeft}>
        <Typography variant="title" level={level}>
          {title}
        </Typography>
        {titleTooltip ? (
          <InfoIconTooltip
            title={titleTooltip}
            iconSize={iconSize[level as keyof typeof iconSize]}
          />
        ) : null}
        {LeftActions ? <LeftActions /> : null}
      </div>
      <div className={styles.headerRight}>
        {RightActions ? <RightActions /> : null}
      </div>
    </div>
  );
};

export default Header;
